<template>
  <div class="">
    <table-component
      :items="items"
      :busy="busy"
      :fields="fields"
      @view="viewRecord"
      @delete="deleteRecord"
      @edit="editRecord"
      :perPage="perPage"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :paginationRange="count"
      :totalRecord="totalRows"
      :totalPages="pages"
      @page-changed="list"
    >
      <!-- <template #search>
        <search-filter
          @filter="filter"
          searchPlaceholder="Search Enrollees"
          @refresh="list"
        />
      </template> -->
      <!-- <template #button>
        <router-link to="/admins/create">
          <button class="veo-btn veo-primary">Add New Admin</button>
        </router-link>
      </template> -->
    </table-component>
  </div>
</template>

<script>
import TableComponent from "@/components/TableComponent.vue";
// import SearchFilter from "@/components/filters/SearchFilter.vue";
export default {
  components: { TableComponent },
  data() {
    return {
      items: [],
      busy: false,
      fields: [
        {
          key: "photo",
          label: "",
        },
        {
          key: "userDetails",
          label: "Name",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "unique_id",
          label: "Unique ID",
        },
        {
          key: "created_at",
          label: "Date",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      currentPage: 1,
      perPage: 0,
      totalRows: 0,
      count: 1,
      pages: 1,
      prevRoute: null,
    };
  },

  methods: {
    list(page = 1) {
      this.busy = true;
      this.$config
        .fetchRemovalRequestRecord(page)
        .then((res) => {
          let resPayload = res.data;
          console.log(resPayload);
          //   this.items = resPayload.data;
          let newList = [];
          resPayload.data.forEach((elem) => {
            console.log("each element:", elem);
            let newData = {
              ...elem.user,
              created_at: elem.created_at,
              id: elem.id,
              user_id: elem.user_id,
            };
            console.log(newData);
            newList.push({
              ...newData,
            });
          });
          this.items = newList;
          console.log(this.items);
          // let meta = resPayload.meta.pagination;
          // this.currentPage = meta.current_page;
          // this.totalRows = meta.total;
          // this.perPage = meta.per_page;
          // this.count = meta.count;
          // this.pages = meta.total_pages;
          return res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.busy = false;
        });
    },

    viewRecord(value) {
      this.$router.push(`/enrollee/view/${value.user_id}`);
    },

    editRecord(value) {
      this.$router.push(`/enrollee/${value.id}/edit`);
    },

    complete(value) {
      this.$users
        .deleteEnrollee(value.id)
        .then((res) => {
          this.$swal.fire(
            "Deleted!",
            "Enrollee deleted succesfully.",
            "success"
          );
          this.list();
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteRecord(value) {
      this.$swal
        .fire({
          title: "Continue?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          console.log(result, "kkk");
          if (result.isConfirmed) {
            this.complete(value);
          }
        });
    },

    filter(value) {
      console.log(value);
      this.busy = true;
      let payload = {
        search: value,
      };
      if (value === "") {
        this.list();
      } else {
        this.$users
          .searchEnrollees(payload)
          .then((res) => {
            let resPayload = res.data;
            console.log(resPayload, "ommo");
            this.items = resPayload;
            this.busy = false;
            return res;
          })
          .catch((err) => {
            console.log(err);
            this.busy = false;
          });
      }
    },
  },

  beforeMount() {
    this.list();
  },
};
</script>

<style></style>
